import React, { useState } from "react";
import { ChevronLeft, Download } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/Brand";

// Reusable install helpers
let deferredPrompt = null;
if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferredPrompt = e;
  });
}

export function useInstallPrompt() {
  const [installed, setInstalled] = useState(false);
  const isIOS = typeof navigator !== "undefined" && /iphone|ipad|ipod/i.test(navigator.userAgent);
  const promptInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === "accepted") setInstalled(true);
      deferredPrompt = null;
      return "prompted";
    }
    return isIOS ? "ios" : "unavailable";
  };
  return { promptInstall, isIOS, installed };
}

export function PageHeader({ title, subtitle, showLogo = false, onBack }) {
  const navigate = useNavigate();
  return (
    <div className="sticky top-0 z-30 bg-[#D8C3A5]/95 backdrop-blur-md border-b border-[#1F2A44]/15 safe-top">
      <div className="flex items-center gap-3 px-4 h-14">
        <button
          onClick={() => (onBack ? onBack() : navigate(-1))}
          data-testid="page-back-btn"
          className="w-10 h-10 -ml-2 rounded-full flex items-center justify-center active:scale-95 transition-transform"
          aria-label="Go back"
        >
          <ChevronLeft className="text-[#1F2A44]" />
        </button>
        <div className="flex-1 min-w-0">
          <h1 className="text-lg font-semibold text-[#1F2A44] truncate">{title}</h1>
          {subtitle && <p className="text-xs text-[#1F2A44]/65 truncate">{subtitle}</p>}
        </div>
        {showLogo && <Logo size={38} />}
      </div>
    </div>
  );
}

export { Download };
